import BlizzardIcon from 'app/frontend/base/components/BlizzardIcon'
import CharacterClassIcon from 'app/frontend/base/components/CharacterClassIcon'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { classColours } from 'app/frontend/types/custom/CharacterClass'
import { cn } from '@/lib/utils'

type Props = {
  candidate: wowaudit.GuildCandidate
  compact?: boolean
}

const CandidateName = ({ candidate, compact }: Props) => {
  const character = candidate.characterReference
  const iconSize = compact ? 'small' : 'medium'

  return (
    <div
      className={cn('flex items-center min-w-0', compact ? 'gap-1.5' : 'gap-2')}
    >
      <Tooltip>
        <TooltipTrigger asChild>
          <span className='inline-flex items-center shrink-0'>
            {candidate.specDetails ? (
              <BlizzardIcon
                size={iconSize}
                iconName={candidate.specDetails.icon}
              />
            ) : (
              <CharacterClassIcon
                size={iconSize}
                characterClass={character.characterClass}
              />
            )}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          {candidate.specDetails
            ? `${candidate.specDetails.name} ${character.characterClass}`
            : character.characterClass}
        </TooltipContent>
      </Tooltip>
      <span
        className={cn(
          'truncate min-w-0 block max-w-full',
          classColours[character.characterClass].text,
        )}
      >
        {character.name}
      </span>
    </div>
  )
}

export default CandidateName
